import * as React from 'react';

import { Button } from '../../components/Button';
import { Text } from '../../components/Text';
import { Icon } from '../../components/Icon';
import { TextAndIcon } from '../../components/TextAndIcon';
import { MountPopup } from '../../components/PopupViewer/MountPopup';
import { Container } from '../../components/Container';
import { SIZE_4, SIZE_20, SIZE_24, SIZE_28, SIZE_40, SIZE_360, SIZE_WIDE } from '../../constants/sizes';
import { ClickOutside } from '../../components/outside/ClickOutside';
import { Link } from '../../components/Link';
import { connect } from 'react-redux';
import {
  trackingActionClickPopupNV,
  trackProblemMoreButtonClick,
  trackReliableIconHover,
} from '../../actions/analytics';
import { TTypedThunkDispatch } from '../../types/thunk';

interface IPopupDispatchProps {
  trackingClickPopupNV(): void;
}

interface IPopupOwnProps {
  url: string;
  GKId: number;
}

type TPopupProps = IPopupOwnProps & IPopupDispatchProps;

interface IPopupState {
  isOpen: boolean;
}

export class ReliableChoicePopupComponent extends React.PureComponent<TPopupProps, IPopupState> {
  public state: Readonly<IPopupState> = {
    isOpen: false,
  };

  private onIconHover = () => {
    const { GKId } = this.props;
    trackReliableIconHover(GKId);
  }

  private onMoreButtonClick = () => {
    const { GKId, trackingClickPopupNV } = this.props;
    trackingClickPopupNV();
    trackProblemMoreButtonClick(GKId);
  }

  public render() {
    const {
      isOpen,
    } = this.state;

    let { url = '' } = this.props;

    if (url) {
      url = `${url}#reliable`;
    }

    return (
      <span
        onMouseEnter={this.handleToggle(true)}
        onMouseLeave={this.handleToggle(false)}
        onClick={this.handleToggle(true)}
      >
        <MountPopup
          placement="bottom"
          padding={-20}
          component={
            isOpen &&
              <ClickOutside
                onOutside={this.handleToggle(false)}
              >
                <div
                  onMouseLeave={this.handleToggle(false)}
                >
                  <Container
                    padding={`${SIZE_28} 0 0`}
                  >
                    <Container
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      shadow
                      borderColor="gray_0"
                      borderStyle="solid"
                      backgroundColor="white"
                      maxWidth={SIZE_WIDE}
                      width={SIZE_360}
                      padding={`${SIZE_24} 0 ${SIZE_40}`}
                    >
                      <Container
                      >
                        <Icon type="reliably" color="green" size={48} />
                      </Container>
                      <Container
                        padding={`${SIZE_4} 0`}
                      >
                        <Text fontSize={16} fontWeight="bold">Проверено ЦИАН</Text>
                      </Container>
                      <Text fontSize={14}>
                        В ЖК есть корпуса, проверенные ЦИАН.
                      </Text>
                      <Container
                        padding={`${SIZE_20} 0 0`}
                      >
                        <Link onClick={this.onMoreButtonClick} url={url} target="blank">
                          <Button type="secondary">Узнать подробнее</Button>
                        </Link>
                      </Container>
                    </Container>
                  </Container>
                </div>
              </ClickOutside>
          }
        >
          <Container
            onMouseEnter={this.onIconHover}
          >
            <TextAndIcon
              iconType="reliably"
              reverse color={isOpen ? 'green_darken' : 'green'}
              iconColor={isOpen ? 'green_darken' : 'green'}
              fontWeight="bold"
              alignItems="baseline"
              offset={4}
              fontSize={12}
              iconSize={12}
            >
              Проверено ЦИАН
            </TextAndIcon>
          </Container>
        </MountPopup>
      </span>
    );
  }

  private handleToggle = (value?: boolean) => () => {
    const { isOpen } = this.state;

    this.setState({ isOpen: value || !isOpen });
  }
}

function mapDispatchToProps(dispatch: TTypedThunkDispatch): IPopupDispatchProps {
  return {
    trackingClickPopupNV() {
      dispatch(trackingActionClickPopupNV());
    },
  };
}

export const ReliableChoicePopup = connect(null, mapDispatchToProps)(ReliableChoicePopupComponent);
